define('views/modules/template/assignment/list/per-template/assignment-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/template/assignment/list/per-template/assignment-list-item',
    // collections
    'collections/template/assignments'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VAssignmentListItem,
    // collection
    CTemplateAssignments
) {

    var VAssignmentList = VFetchList.extend({
        item: VAssignmentListItem,

        initialize: function(opt) {
            VAssignmentList.__super__.initialize.apply(this, arguments);
            this.selectedCollection = new CTemplateAssignments();
            this.listenTo(this.collection, {
                'assignment:click': this.onAssignmentClick,
            });
        },

        onAssignmentClick: function(model, val) {
            if (val) {
                this.selectedCollection.add(model);
            } else {
                this.selectedCollection.remove(model, { silent: true });
            }
            this.trigger('selected:change', this.selectedCollection, val);
        },

        reset: function() {
            this.selectedCollection.reset();
            this.$('.assignment-list-item').removeClass('active');
            this.trigger('selected:change', false, this.selectedCollection);
        },

        getSelectedCollection: function() {
            return this.selectedCollection;
        },
    });

    return VAssignmentList;
});

